import Vue from 'vue'
import Router from 'vue-router'
import global from '@/core/global/global'
var param = global.global.getParam();


Vue.use(Router)


import configuration_routers from "./configuration_routers" //系统配置
import dangan_routers from "./dangan_routers" //系统配置
import manage_routers from "./manage_routers"//登录注册
import contributionManagement_routers from "./contributionManagement_routers"//稿件管理
import system_routers from "./system_routers" //共用页面 用户反馈、帮助中心、个人中心等

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

var projects = [
  configuration_routers,//系统配置
  manage_routers,
  dangan_routers,
  contributionManagement_routers,
  system_routers
]

var routes = (branches) => {
  var merge = [];
  branches.map(function(item) {
    merge.push.apply(merge, item);
  })
  return merge;
}
var router = new Router({
  routes: routes(projects)
})


router.beforeEach((to, from, next) => {
  if(to.path=='/manage/author'){
    next()
  }else if(to.path=='/'){
      window.location.href=global.global.url+'/logout?Authorization='+param.token||'';
  }else{
    next()
  }
  // else{
  //   if(session){
  //     next()
  //   }else{
  //     next({path: '/loginAdmin'})
  //   }
  // }

})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js